import { useLocation } from 'react-router';

import { getPathSegmentsFromPathname } from '../utils/getPathSegmentsFromPathname';
import { isValidEmail } from '../validation';

export function useEmailFromUrl() {
  const { pathname } = useLocation();
  const pathSegments = getPathSegmentsFromPathname(pathname);
  const maybeEmail = pathSegments.at(-1)!;

  return isValidEmail(maybeEmail) ? maybeEmail : null;
}
